import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ApiMode, ConfigService, ConnectMode} from '@shared-library';
import {RecaptchaService} from './services/recaptcha.service';
import {environment} from "../environments/environment";
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'fastenhealth';

  constructor(
    public router: Router,
    public configService: ConfigService,
  ) {}

  ngOnInit() {
    const navbarBackdrop = document.createElement('div');
    navbarBackdrop.classList.add('az-navbar-backdrop');
    document.querySelector('body')?.appendChild(navbarBackdrop);

    const urlParams = new URLSearchParams(window.location.search);
    this.configService.systemConfig = {
      apiMode: this.getApiModeFromPublicId(this.configService.systemConfig$.publicId || environment.org_credential_live_public_id),
      publicId: this.configService.systemConfig$.publicId || environment.org_credential_live_public_id,
      externalId: urlParams.get('external-id') || '',
      tefcaMode: true,
      connectMode: ConnectMode.Popup,
    };
  }

  get currentPath(): string {
    return this.router.url.split('?')[0];
  }

  get isSigninRoute(): boolean {
    return this.currentPath === '/auth/signin';
  }

  get isDashboardChromeRoute(): boolean {
    return this.currentPath.startsWith('/dashboard')
      || this.currentPath.startsWith('/search')
      || this.currentPath.startsWith('/brand/');
  }

  get isWideSurfaceRoute(): boolean {
    return this.isDashboardChromeRoute
      || this.currentPath.startsWith('/auth/callback')
      || this.currentPath.startsWith('/auth/identity/verification')
      || this.currentPath.startsWith('/form');
  }

  get activeDashboardSection(): 'apps' | 'accounts' | 'settings' {
    if (this.currentPath.startsWith('/dashboard/settings')) {
      return 'settings';
    }

    if (
      this.currentPath.startsWith('/dashboard/accounts')
      || this.currentPath.startsWith('/search')
      || this.currentPath.startsWith('/brand/')
    ) {
      return 'accounts';
    }

    return 'apps';
  }

  get bannerClasses(): string {
    if (this.isWideSurfaceRoute) {
      return 'bg-[#DC3545] text-white text-center py-2 px-4 font-medium text-sm flex items-center justify-center gap-2';
    }

    return 'bg-[#DC3545] text-white text-center py-2 px-4 font-medium text-sm flex items-center justify-center gap-2';
  }

  private getApiModeFromPublicId(publicId: string): ApiMode {
    const publicIdParts = publicId.split('_');
    if (publicIdParts.length === 3 && publicIdParts[1] === ApiMode.Live) {
      return ApiMode.Live;
    }
    return ApiMode.Test;
  }
}
